import { TypedDocumentNode, gql } from '@apollo/client';

import { Sport } from '__generated__/globalTypes';

import { ClaimReferralRewardsDialog } from '../ClaimReferralRewardsDialog';
import { ClaimReferralRewardDialog_referralReward } from './__generated__/index.graphql';

type Props = {
  open: boolean;
  onClose: () => void;
  referralReward: ClaimReferralRewardDialog_referralReward | null;
  sport: Sport | undefined;
};

export const ClaimReferralRewardDialog = ({
  open,
  onClose,
  referralReward,
  sport,
}: Props) => {
  return (
    <ClaimReferralRewardsDialog
      open={open}
      onClose={onClose}
      referralRewards={referralReward ? [referralReward] : []}
      sport={sport}
    />
  );
};

ClaimReferralRewardDialog.fragments = {
  referralReward: gql`
    fragment ClaimReferralRewardDialog_referralReward on ReferralReward {
      id
      ...ClaimReferralRewardsDialog_referralReward
    }
    ${ClaimReferralRewardsDialog.fragments.referralReward}
  ` as TypedDocumentNode<ClaimReferralRewardDialog_referralReward>,
};
